import { UserModel } from "domains/models/UserModel";
import M5APIs from "m5/M5APIs";
import * as config from "../../../_config";
import { makeAutoObservable, action, computed, observable } from "mobx";
import { M5Doc } from "m5/models/M5Doc";
import { AssessModel } from "domains/models/AssessModel";
import moment from "moment";
import { TaskModel } from "domains/models/TaskModel";

class TimelinePageStore {
  @observable private _containers = [];
  @observable private _userInfo: UserModel = {
    email: "",
    id: "",
    names: {
      fullname: "",
    },
    orgCode: "",
    paid: false,
    status: "",
    tier: "",
    username: "",
    userData: {
      deptName: "",
      jobTitle: "",
    },
  };
  @observable _assess?: AssessModel;
  @observable private _task: TaskModel = {
    contents: "",
    created: 0,
    status: "TODO",
    subtype: "EMAIL",
    title: "",
    type: "TASK",
    children: [],
  };
  @observable private _total = 0;
  @observable private _assessList: Array<AssessModel> = [];
  @observable private _isChecked: boolean = false;
  @observable private _isOpenModal: boolean = false;
  @observable private _tabValue: string = "downwards";
  @observable private _filterValue: string = "";
  @observable private _filterLikeUp: boolean = false;
  @observable private _filterLikeDown: boolean = false;
  @observable private _last30dayAvg: number = 0;
  @observable private _quarterAvg: number = 0;
  @observable private _halfAvg: number = 0;
  @observable private _yearAvg: number = 0;
  @observable private _yearEmojiCount: number = 0;
  @observable private _quarterEmojiCount: number = 0;
  @observable private _halfEmojiCount: number = 0;
  @observable private _last30dayEmojiCount: number = 0;
  @observable private _isLoading: boolean = false;
  @observable private _labels: string[] = [];
  @observable private _scores: any = [];
  @observable private _period = "year";
  @observable private _emogiList: any[] = [];
  @observable private _totalEmoji: number = 0;
  @observable private _maxEmojiCount: number = 0;
  @observable private _minEmojiCount: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  initStore() {
    this._filterLikeDown = false;
    this._filterLikeUp = true;
    this._filterValue = "";
  }

  @action
  async fetchChartData(period: string) {
    this._isLoading = true;

    this._scores = [];
    this._labels = [];
    let tempEmogiArr: any[] = [
      {
        emoji: "👍",
        isHover: false,
        count: 0,
      },
      {
        emoji: "⭕",
        isHover: false,
        count: 0,
      },
      {
        emoji: "🙂",
        isHover: false,
        count: 0,
      },
      {
        emoji: "👎",
        isHover: false,
        count: 0,
      },
      {
        emoji: "❌",
        isHover: false,
        count: 0,
      },
      {
        emoji: "😥",
        isHover: false,
        count: 0,
      },
      {
        emoji: "😐",
        isHover: false,
        count: 0,
      },
      {
        emoji: "🤔",
        isHover: false,
        count: 0,
      },
    ];
    this._totalEmoji = 0;

    if (period === "year") {
      for (let i = 2; i >= 0; i--) {
        if (i === 0) {
          this._labels = [...this._labels, moment().format("YYYY")];
        } else {
          this._labels = [
            ...this._labels,
            moment().subtract(i, "year").format("YYYY"),
          ];
        }
      }
      let currentSum = 0;
      let lastYearSum = 0;
      let last2yearSum = 0;

      let currentCount = 0;
      let lastYearCount = 0;
      let last2YearCount = 0;

      for (let j = 0; j < this._assessList.length; j++) {
        if (this._assessList[j].subtype === "INVISIBLE") {
          if (
            this._assessList[j].created! < moment().valueOf() &&
            this._assessList[j].created! > moment().startOf("year").valueOf()
          ) {
            currentSum =
              currentSum + Number(this._assessList[j].userData.grade);
            currentCount = currentCount + 1;
          } else if (
            this._assessList[j].created! <
            moment().subtract(1, "year").endOf("year").valueOf() &&
            this._assessList[j].created! >
            moment().subtract(1, "year").startOf("year").valueOf()
          ) {
            lastYearSum =
              lastYearSum + Number(this._assessList[j].userData.grade);
            lastYearCount = lastYearCount + 1;
          } else if (
            this._assessList[j].created! <
            moment().subtract(2, "year").endOf("year").valueOf() &&
            this._assessList[j].created! >
            moment().subtract(2, "year").startOf("year").valueOf()
          ) {
            last2yearSum =
              last2yearSum + Number(this._assessList[j].userData.grade);
            last2YearCount = last2YearCount + 1;
          }
        } else {
          // 공개..
          if (
            this._assessList[j].created! < moment().valueOf() &&
            this._assessList[j].created! > moment().startOf("year").valueOf()
          ) {
            for (let i = 0; i < tempEmogiArr.length; i++) {
              if (
                this._assessList[j].userData?.emoticon === tempEmogiArr[i].emoji
              ) {
                tempEmogiArr[i].count = tempEmogiArr[i].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }

          this._emogiList = tempEmogiArr;
        }
      }
      if (currentCount === 0) {
        currentCount = 1;
      }
      if (lastYearCount === 0) {
        lastYearCount = 1;
      }
      if (last2YearCount === 0) {
        last2YearCount = 1;
      }
      this._scores = [...this._scores, last2yearSum / last2YearCount];
      this._scores = [...this._scores, lastYearSum / lastYearCount];
      this._scores = [...this._scores, currentSum / currentCount];
    } else if (period === "quarter") {
      const quarter = moment().quarter();
      const startOfQuarter = moment()
        .startOf("year")
        .add(3 * quarter - 3, "months");
      const months = [];

      for (let i = 2; i >= 0; i--) {
        const month = startOfQuarter
          .clone()
          .add(2 - i, "months")
          .format("MMM");
        this._labels = [...this._labels, month];
      }
      let currentSum = 0;
      let quarter1Sum = 0;
      let quarter2Sum = 0;

      let currentCount = 0;
      let quarter1Count = 0;
      let quarter2Count = 0;

      for (let j = 0; j < this._assessList.length; j++) {
        if (this._assessList[j].subtype === "VISIBLE") {
          if (
            this._assessList[j].created! <
            startOfQuarter
              .clone()
              .add(2, "months")
              .endOf("month")
              .valueOf() &&
            this._assessList[j].created! >
            startOfQuarter.clone().add(0, "months").startOf("month").valueOf()
          ) {
            for (let i = 0; i < tempEmogiArr.length; i++) {
              if (
                this._assessList[j].userData?.emoticon === tempEmogiArr[i].emoji
              ) {
                tempEmogiArr[i].count = tempEmogiArr[i].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }

      this._emogiList = tempEmogiArr;

      for (let j = 0; j < this._assessList.length; j++) {
        if (this._assessList[j].subtype === "INVISIBLE") {
          if (
            this._assessList[j].created! <
            startOfQuarter
              .clone()
              .add(2, "months")
              .endOf("month")
              .valueOf() &&
            this._assessList[j].created! >
            startOfQuarter.clone().add(2, "months").startOf("month").valueOf()
          ) {
            currentSum =
              currentSum + Number(this._assessList[j].userData.grade);
            currentCount = currentCount + 1;
          } else if (
            this._assessList[j].created! <
            startOfQuarter
              .clone()
              .add(1, "months")
              .endOf("month")
              .valueOf() &&
            this._assessList[j].created! >
            startOfQuarter.clone().add(1, "months").startOf("month").valueOf()
          ) {
            quarter1Sum =
              quarter1Sum + Number(this._assessList[j].userData.grade);
            quarter1Count = quarter1Count + 1;
          } else if (
            this._assessList[j].created! <
            startOfQuarter
              .clone()
              .add(0, "months")
              .endOf("month")
              .valueOf() &&
            this._assessList[j].created! >
            startOfQuarter.clone().add(0, "months").startOf("month").valueOf()
          ) {
            quarter2Sum =
              quarter2Sum + Number(this._assessList[j].userData.grade);
            quarter2Count = quarter2Count + 1;
          }
        }
      }
      if (currentCount === 0) {
        currentCount = 1;
      }
      if (quarter1Count === 0) {
        quarter1Count = 1;
      }
      if (quarter2Count === 0) {
        quarter2Count = 1;
      }
      this._scores = [...this._scores, quarter2Sum / quarter2Count];
      this._scores = [...this._scores, quarter1Sum / quarter1Count];
      this._scores = [...this._scores, currentSum / currentCount];
    } else if (period === "half") {
      const quarter = moment().quarter();
      const halfYear = quarter <= 2 ? 1 : 2;
      const firstMonthInHalfYear = (halfYear - 1) * 6 + 1;
      const lastMonthInHalfYear = firstMonthInHalfYear + 5;

      for (let i = firstMonthInHalfYear; i <= lastMonthInHalfYear; i++) {
        for (let j = 0; j < this._assessList.length; j++) {
          if (
            this._assessList[j].subtype === "VISIBLE" &&
            typeof this._assessList[j].userData?.emoticon === "string"
          ) {
            if (
              this._assessList[j].created! <
              moment().month(i).endOf("month").valueOf() &&
              this._assessList[j].created! >
              moment().month(i).startOf("month").valueOf()
            ) {
              for (let k = 0; k < tempEmogiArr.length; k++) {
                if (
                  this._assessList[j].userData?.emoticon ===
                  tempEmogiArr[k].emoji
                ) {
                  tempEmogiArr[k].count = tempEmogiArr[k].count + 1;
                  this._totalEmoji = this._totalEmoji + 1;
                }
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;

      for (let i = lastMonthInHalfYear; i >= firstMonthInHalfYear; i--) {
        const month = moment()
          .year(moment().year())
          .month(6 - i)
          .format("MMM");
        this._labels = [...this._labels, month];
      }

      for (let i = lastMonthInHalfYear; i >= firstMonthInHalfYear; i--) {
        let sum = 0;
        let count = 0;
        for (let j = 0; j < this._assessList.length; j++) {
          if (this._assessList[j].subtype === "INVISIBLE") {
            if (
              this._assessList[j].created! <
              moment().month(i).endOf("month").valueOf() &&
              this._assessList[j].created! >
              moment().month(i).startOf("month").valueOf()
            ) {
              sum = sum + Number(this._assessList[j].userData.grade);
              count = count + 1;
            }
          }
        }

        if (count === 0) {
          count = 1;
        }
        this._scores = [...this._scores, sum / count];
      }
    } else {
      for (let i = 0; i < this._assessList.length; i++) {
        if (
          this._assessList[i].subtype === "VISIBLE" &&
          typeof this._assessList[i].userData?.emoticon === "string"
        ) {
          if (
            this._assessList[i].created! >
            moment().subtract(30, "days").valueOf() &&
            this._assessList[i].created! < moment().valueOf()
          ) {
            for (let j = 0; j < tempEmogiArr.length; j++) {
              if (
                this._assessList[i].userData?.emoticon === tempEmogiArr[j].emoji
              ) {
                tempEmogiArr[j].count = tempEmogiArr[j].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;

      for (let i = 29; i >= 0; i--) {
        this._labels = [
          ...this._labels,
          moment().subtract(i, "day").format("MM/DD"),
        ];
      }

      for (let i = 29; i >= 0; i--) {
        let sum = 0;
        let count = 0;
        for (let j = 0; j < this._assessList.length; j++) {
          if (this._assessList[j].subtype === "INVISIBLE") {
            if (
              this._assessList[j].created! >
              moment().subtract(i, "day").startOf("day").valueOf() &&
              this._assessList[j].created! <
              moment().subtract(i, "day").endOf("day").valueOf()
            ) {
              sum = sum + Number(this._assessList[j].userData.grade);
              count = count + 1;
            }
          }
        }
        if (count === 0) {
          count = 1;
        }
        this._scores = [...this._scores, sum / count];
      }
    }

    tempEmogiArr.sort((a, b) => b.count - a.count);
    this._maxEmojiCount = tempEmogiArr[0].count;
    this._minEmojiCount =
      tempEmogiArr[tempEmogiArr.length - 1].count === 0
        ? 1
        : tempEmogiArr[tempEmogiArr.length - 1].count;
  }

  @action
  async fetchAsssessListWithPeriod(userId: string) {
    try {
      this._isLoading = true;
      let userRes: any = await this.setWhere();

      let period = {};
      let like = {};
      const curYear = moment().year();
      const curMonth = moment().month() + 1;
      if (this._filterValue === "quarter") {
        let startMonth = 0;
        let endMonth = 2;
        // 1분기
        if (moment().format("Q") === "1") {
          startMonth = 0;
          endMonth = 2;
        }
        // 2분기
        else if (moment().format("Q") === "2") {
          startMonth = 3;
          endMonth = 5;
        }
        // 3분기
        else if (moment().format("Q") === "3") {
          startMonth = 6;
          endMonth = 8;
        }
        // 4분기
        else {
          startMonth = 9;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "half") {
        let startMonth = 0;
        let endMonth = 2;
        //전반기 일떄
        if (curMonth < 7) {
          startMonth = 0;
          endMonth = 5;
        }
        //후반기 일때
        else {
          startMonth = 6;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "year") {
        let newDate = new Date(curYear, 0, 1);
        let newDate2 = new Date(curYear, 11, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "last30day") {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "month").valueOf(), moment().valueOf()],
        };
      } else {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "year").valueOf(), moment().valueOf()],
        };
      }
      if (this._filterLikeDown) {
        like = {
          condition: "AND",
          field: "userData.`like`",
          compare: "=",
          value: "false",
        };
      } else if (this._filterLikeUp) {
        like = {
          condition: "AND",
          field: "userData.`like`",
          compare: "=",
          value: "true",
        };
      }

      let tempUserList: any = [];
      let response: any;
      if (this._filterLikeDown && this._filterLikeUp) {
        response = await M5APIs.fetchDocs<any>(config.BUCKET_TASK!, "ASSESS", {
          fetchParents: true,
          where: {
            filters: [
              period,
              {
                condition: "AND",
                field: "(",
              },
              {
                field: "userData.`like`",
                compare: "=",
                value: "true",
              },
              {
                condition: "OR",
                field: "userData.`like`",
                compare: "=",
                value: "false",
              },
              {
                field: ")",
              },
              {
                condition: "AND",
                field: "userId",
                compare: "=",
                value: userId,
              },
            ],
          },
        });
      } else if (this._filterLikeDown || this._filterLikeUp) {
        response = await M5APIs.fetchDocs<any>(config.BUCKET_TASK!, "ASSESS", {
          fetchParents: true,
          where: {
            filters: [
              period,
              like,
              {
                condition: "AND",
                field: "subtype",
                compare: "=",
                value: 'VISIBLE',
              },
              {
                condition: "AND",
                field: "userId",
                compare: "=",
                value: userId,
              },
            ],
          },
        });
      } else {
        response = await M5APIs.fetchDocs<any>(config.BUCKET_TASK!, "ASSESS", {
          fetchParents: true,
          where: {
            filters: [
              period,
              // {
              //   condition: "AND",
              //   field: "subtype",
              //   compare: "=",
              //   value: 'VISIBLE',
              // },
              {
                condition: "AND",
                field: "userId",
                compare: "=",
                value: userId,
              },
            ],
          },
        });
      }

      let sumLast30 = 0;
      let sumYear = 0;
      let sumHalf = 0;
      let sumQuarter = 0;

      let countLast30 = 0;
      let countYear = 0;
      let countHalf = 0;
      let countQuarter = 0;

      if (response.docs && response.docs.length !== 0) {
        for (let i = 0; i < response.docs.length; i++) {
          if (response.docs[i].subtype === "INVISIBLE") {
            const createTime = response.docs[i].created!;
            const curYear = moment().year();
            const curMonth = moment().month() + 1;
            // console.log(response.docs[i].id, response.docs[i].userData.grade);

            //30일 카우트
            if (
              createTime > moment().subtract(1, "month").valueOf() &&
              createTime <= moment().valueOf()
            ) {
              sumLast30 = sumLast30 + Number(response.docs[i].userData.grade!);
              countLast30 = countLast30 + 1;
            }

            // 1년 카운트
            let newYDate = new Date(curYear, 0, 1);
            let newYDate2 = new Date(curYear, 11, 31);
            if (
              createTime > moment(newYDate).valueOf() &&
              createTime <= moment(newYDate2).valueOf()
            ) {
              sumYear = sumYear + Number(response.docs[i].userData.grade!);
              countYear = countYear + 1;
            }
            // 반기 카운트
            let startMonth = 0;
            let endMonth = 2;
            //전반기 일떄
            if (curMonth < 7) {
              startMonth = 0;
              endMonth = 5;
            }
            //후반기 일때
            else {
              startMonth = 6;
              endMonth = 11;
            }
            let neQDate = new Date(curYear, startMonth, 1);
            let newQDate2 = new Date(curYear, endMonth, 31);
            if (
              createTime > moment(neQDate).valueOf() &&
              createTime <= moment(newQDate2).valueOf()
            ) {
              sumHalf = sumHalf + Number(response.docs[i].userData.grade!);
              countHalf = countHalf + 1;
            }
            let startHMonth = 0;
            let endHMonth = 2;
            // 1분기
            if (moment().format("Q") === "1") {
              startHMonth = 0;
              endHMonth = 2;
            }
            // 2분기
            else if (moment().format("Q") === "2") {
              startHMonth = 3;
              endHMonth = 5;
            }
            // 3분기
            else if (moment().format("Q") === "3") {
              startHMonth = 6;
              endHMonth = 8;
            }
            // 4분기
            else {
              startHMonth = 9;
              endHMonth = 11;
            }

            let newHDate = new Date(curYear, startHMonth, 1);
            let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
            if (
              createTime > moment(newHDate).valueOf() &&
              createTime <= moment(newHDate2).valueOf()
            ) {
              sumQuarter =
                sumQuarter + Number(response.docs[i].userData.grade!);
              countQuarter = countQuarter + 1;
            }
          } else {
            if (response.docs[i].userData.emoticon !== 0) {
              const createTime = response.docs[i].created!;
              const curYear = moment().year();
              const curMonth = moment().month() + 1;
              //console.log(response.docs[i].id, response.docs[i].userData.grade);

              //30일 카우트
              if (
                createTime > moment().subtract(1, "month").valueOf() &&
                createTime <= moment().valueOf()
              ) {
                this._last30dayEmojiCount = this._last30dayEmojiCount + 1;
              }

              // 1년 카운트
              let newYDate = new Date(curYear, 0, 1);
              let newYDate2 = new Date(curYear, 11, 31);
              if (
                createTime > moment(newYDate).valueOf() &&
                createTime <= moment(newYDate2).valueOf()
              ) {
                this._yearEmojiCount = this._yearEmojiCount + 1;
              }
              // 반기 카운트
              let startMonth = 0;
              let endMonth = 2;
              //전반기 일떄
              if (curMonth < 7) {
                startMonth = 0;
                endMonth = 5;
              }
              //후반기 일때
              else {
                startMonth = 6;
                endMonth = 11;
              }
              let neQDate = new Date(curYear, startMonth, 1);
              let newQDate2 = new Date(curYear, endMonth, 31);
              if (
                createTime > moment(neQDate).valueOf() &&
                createTime <= moment(newQDate2).valueOf()
              ) {
                this._halfEmojiCount = this._halfEmojiCount + 1;
              }
              let startHMonth = 0;
              let endHMonth = 2;
              // 1분기
              if (moment().format("Q") === "1") {
                startHMonth = 0;
                endHMonth = 2;
              }
              // 2분기
              else if (moment().format("Q") === "2") {
                startHMonth = 3;
                endHMonth = 5;
              }
              // 3분기
              else if (moment().format("Q") === "3") {
                startHMonth = 6;
                endHMonth = 8;
              }
              // 4분기
              else {
                startHMonth = 9;
                endHMonth = 11;
              }

              let newHDate = new Date(curYear, startHMonth, 1);
              let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
              if (
                createTime > moment(newHDate).valueOf() &&
                createTime <= moment(newHDate2).valueOf()
              ) {
                this._quarterEmojiCount = this._quarterEmojiCount + 1;
              }
            }
          }
        }

        this._halfAvg = sumHalf / countHalf;
        this._yearAvg = sumYear / countYear;
        this._quarterAvg = sumQuarter / countQuarter;
        this._last30dayAvg = sumLast30 / countLast30;
      }

      response.docs?.forEach((assess: AssessModel, index: number) => {
        let tempParents: TaskModel[] = [];
        response.parents?.forEach((doc: any) => {
          if (doc.id === assess.parentId) {
            tempParents.push(doc);
          }
        });
        assess.parents = tempParents;
      });

      let tempAssessList: any = [];

      if (response.docs) {
        for (let i = 0; i < response.docs?.length; i++) {
          for (let j = 0; j < userRes.users.length; j++) {
            if (
              userRes.users[j].email ===
              response.docs[i].parents[0]?.userData?.sender?.emailAddress
                ?.address ||
              userRes.users[j].email ===
              response.docs[i].parents[0]?.userData?.user?.id
            ) {
              response.docs[i].user = userRes.users[j];
              // if (response.docs[i].subtype !== "INVISIBLE") {
              tempAssessList.push(response.docs[i]);
              // }
            }
          }
        }
      }

      if (response) {
        this._assessList = tempAssessList;
        this._total = response.total;
      }

      this.fetchChartData(this._period);

      this._isLoading = false;
    } catch (err) {
      throw err;
    }
  }

  async setWhere() {
    let userRes;
    if (this._tabValue === "downwards") {
      let tempIdlist = this.userInfo?.userData.downwardsList?.map(
        (li) => li.id
      );
      userRes = await M5APIs.fetchUsers({
        fetchByFieldValue: "aggregationId",
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "meta().id",
              compare: "IN",
              value: tempIdlist ? tempIdlist : [],
            },
          ],
        }),
      });
    } else if (this._tabValue === "peer") {
      let tempIdlist = this.userInfo?.userData.peerList?.map((li) => li.id);
      userRes = await M5APIs.fetchUsers({
        fetchByFieldValue: "aggregationId",
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "meta().id",
              compare: "IN",
              value: tempIdlist ? tempIdlist : [],
            },
          ],
        }),
      });
    } else {
      let tempIdlist1: any = this.userInfo?.userData.downwardsList?.map(
        (li) => li.id
      );
      let tempIdlist2: any = this.userInfo?.userData.peerList?.map(
        (li) => li.id
      );
      if (!tempIdlist1) {
        tempIdlist1 = [];
      }
      if (!tempIdlist2) {
        tempIdlist2 = [];
      }
      let tempIdlist = [...tempIdlist1, ...tempIdlist2];
      userRes = await M5APIs.fetchUsers({
        fetchByFieldValue: "aggregationId",
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "meta().id",
              compare: "IN",
              value: tempIdlist ? tempIdlist : [],
            },
          ],
        }),
      });
    }

    if (userRes.users) {
      for (let i = 0; i < userRes.users.length; i++) {
        for (let j = 0; j < userRes.children.length; j++) {
          if (
            userRes.users[i].userData.aggregationId === userRes.children[j].id
          ) {
            userRes.users[i].child = userRes.children[j];
          }
        }
      }
      userRes.users = userRes.users.sort((a: any, b: any) => {
        if (
          a.child != null &&
          a.child.userData != null &&
          b.child != null &&
          b.child.userData != null
        ) {
          if (!a.child.userData?.todoCount) {
            a.child.userData.todoCount = 0;
          }
          if (!b.child.userData?.todoCount) {
            b.child.userData.todoCount = 0;
          }

          return b.child.userData?.todoCount - a.child.userData?.todoCount;
        } else {
          return 0;
        }
      });
    }

    return userRes;
  }

  @action
  async fetchTaskByAssessId(assesId: string) {
    try {
      this._isLoading = true;
      let tempUserList: any = [];
      const res: any = await M5APIs.fetchDocById<TaskModel>(
        assesId,
        config.BUCKET_TASK!,
        "TASK",
        {
          page: 0,
          pageSize: 10,
          fetchChildrenJson: [
            {
              types: "ASSESS",
              page: 0,
              pageSize: 100,
            },
          ],
          where: {
            filters: [
              {
                condition: "AND",
                field: "id",
                compare: "=",
                value: assesId,
              },
            ],
          },
        }
      ).then(async (res) => {
        for (let i = 0; i < res.children?.length; i++) {
          let tempUserIdlist = new Set();
          console.log('###CHILDREN', res.children);
          for (let i = 0; i < res.children?.length; i++) {

            tempUserIdlist.add(res.children[i]['userId']);

          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          console.log(userRes);
          tempUserList = userRes.users;
        }
        return res;
      });

      // res.docs.forEach((doc: TaskModel) => {
      let tempChildren: AssessModel[] = [];

      for (let i = 0; i < res.children?.length; i++) {
        const found = tempUserList.find(
          (item: any) => item.id === res.children[i].userId
        );
        console.log(found);
        res.children[i].user = found;
      }

      res.children?.forEach(async (child: any, index: number) => {
        if (res.docs.id === child.parentId && child.subtype === "VISIBLE") {
          tempChildren.push(child);
        }
      });
      res.docs.children = tempChildren;
      // });

      this._task = res.doc;

      // filter subtype of 'VISIBLE'
      // this._task.children = this._task.children.filter(
      //   (child: any) => child.subtype === "VISIBLE"
      // );
      this._task.children = tempChildren;// res.children;

      this._isLoading = false;
    } catch (err: any) {
      this._isLoading = false;
      throw err;
    }
  }

  @action
  async fetchAsssessList(userId: string) {
    try {
      this._isLoading = true;

      let userRes: any = await this.setWhere();

      let tempUserList: any = [];
      const response = await M5APIs.fetchDocs<any>(
        config.BUCKET_TASK!,
        "ASSESS",
        {
          fetchParents: true,
          page: 0,
          pageSize: 30,
          where: {
            filters: [
              {
                condition: "AND",
                field: "subtype",
                compare: "=",
                value: 'VISIBLE',
              },
              {
                condition: "AND",
                field: "userId",
                compare: "=",
                value: userId,
              },
            ],
          },
        }
      );

      let sumLast30 = 0;
      let sumYear = 0;
      let sumHalf = 0;
      let sumQuarter = 0;

      let countLast30 = 0;
      let countYear = 0;
      let countHalf = 0;
      let countQuarter = 0;

      if (response.docs && response.docs.length !== 0) {
        for (let i = 0; i < response.docs.length; i++) {
          if (response.docs[i].subtype === "INVISIBLE") {
            const createTime = response.docs[i].created!;
            const curYear = moment().year();
            const curMonth = moment().month() + 1;

            //30일 카우트
            if (
              createTime > moment().subtract(1, "month").valueOf() &&
              createTime <= moment().valueOf()
            ) {
              sumLast30 = sumLast30 + Number(response.docs[i].userData.grade!);
              countLast30 = countLast30 + 1;
            }

            // 1년 카운트
            let newYDate = new Date(curYear, 0, 1);
            let newYDate2 = new Date(curYear, 11, 31);
            if (
              createTime > moment(newYDate).valueOf() &&
              createTime <= moment(newYDate2).valueOf()
            ) {
              sumYear = sumYear + Number(response.docs[i].userData.grade!);
              countYear = countYear + 1;
            }
            // 반기 카운트
            let startMonth = 0;
            let endMonth = 2;
            //전반기 일떄
            if (curMonth < 7) {
              startMonth = 0;
              endMonth = 5;
            }
            //후반기 일때
            else {
              startMonth = 6;
              endMonth = 11;
            }
            let neQDate = new Date(curYear, startMonth, 1);
            let newQDate2 = new Date(curYear, endMonth, 31);
            if (
              createTime > moment(neQDate).valueOf() &&
              createTime <= moment(newQDate2).valueOf()
            ) {
              sumHalf = sumHalf + Number(response.docs[i].userData.grade!);
              countHalf = countHalf + 1;
            }
            let startHMonth = 0;
            let endHMonth = 2;
            // 1분기
            if (moment().format("Q") === "1") {
              startHMonth = 0;
              endHMonth = 2;
            }
            // 2분기
            else if (moment().format("Q") === "2") {
              startHMonth = 3;
              endHMonth = 5;
            }
            // 3분기
            else if (moment().format("Q") === "3") {
              startHMonth = 6;
              endHMonth = 8;
            }
            // 4분기
            else {
              startHMonth = 9;
              endHMonth = 11;
            }

            let newHDate = new Date(curYear, startHMonth, 1);
            let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
            if (
              createTime > moment(newHDate).valueOf() &&
              createTime <= moment(newHDate2).valueOf()
            ) {
              sumQuarter =
                sumQuarter + Number(response.docs[i].userData.grade!);
              countQuarter = countQuarter + 1;
            }
          } else {
            if (
              response.docs[i].userData.emoticon !== 0 &&
              response.docs[i].userData.emoticon !== undefined
            ) {
              const createTime = response.docs[i].created!;
              const curYear = moment().year();
              const curMonth = moment().month() + 1;

              //30일 카우트
              if (
                createTime > moment().subtract(1, "month").valueOf() &&
                createTime <= moment().valueOf()
              ) {
                this._last30dayEmojiCount = this._last30dayEmojiCount + 1;
              }

              // 1년 카운트
              let newYDate = new Date(curYear, 0, 1);
              let newYDate2 = new Date(curYear, 11, 31);
              if (
                createTime > moment(newYDate).valueOf() &&
                createTime <= moment(newYDate2).valueOf()
              ) {
                this._yearEmojiCount = this._yearEmojiCount + 1;
              }
              // 반기 카운트
              let startMonth = 0;
              let endMonth = 2;
              //전반기 일떄
              if (curMonth < 7) {
                startMonth = 0;
                endMonth = 5;
              }
              //후반기 일때
              else {
                startMonth = 6;
                endMonth = 11;
              }
              let neQDate = new Date(curYear, startMonth, 1);
              let newQDate2 = new Date(curYear, endMonth, 31);
              if (
                createTime > moment(neQDate).valueOf() &&
                createTime <= moment(newQDate2).valueOf()
              ) {
                this._halfEmojiCount = this._halfEmojiCount + 1;
              }
              let startHMonth = 0;
              let endHMonth = 2;
              // 1분기
              if (moment().format("Q") === "1") {
                startHMonth = 0;
                endHMonth = 2;
              }
              // 2분기
              else if (moment().format("Q") === "2") {
                startHMonth = 3;
                endHMonth = 5;
              }
              // 3분기
              else if (moment().format("Q") === "3") {
                startHMonth = 6;
                endHMonth = 8;
              }
              // 4분기
              else {
                startHMonth = 9;
                endHMonth = 11;
              }

              let newHDate = new Date(curYear, startHMonth, 1);
              let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
              if (
                createTime > moment(newHDate).valueOf() &&
                createTime <= moment(newHDate2).valueOf()
              ) {
                this._quarterEmojiCount = this._quarterEmojiCount + 1;
              }
            }
          }
        }

        this._halfAvg = sumHalf / countHalf;
        this._yearAvg = sumYear / countYear;
        this._quarterAvg = sumQuarter / countQuarter;
        this._last30dayAvg = sumLast30 / countLast30;
      }

      response.docs?.forEach((assess: AssessModel, index: number) => {
        let tempParents: TaskModel[] = [];
        response.parents?.forEach((doc: any) => {
          if (doc.id === assess.parentId) {
            tempParents.push(doc);
          }
        });
        assess.parents = tempParents;
      });

      let tempAssessList: any = [];

      if (response.docs) {
        for (let i = 0; i < response.docs?.length; i++) {
          for (let j = 0; j < userRes.users?.length; j++) {
            if (
              userRes.users[j].email ===
              response.docs[i].parents[0]?.userData.sender?.emailAddress
                ?.address
            ) {
              response.docs[i].user = userRes.users[j];

              // if (response.docs[i].subtype !== "INVISIBLE") {
              tempAssessList.push(response.docs[i]);
              // }

            }
          }
        }
      }

      if (response) {
        this._assessList = tempAssessList;
        this._total = response.total;
      }

      this.fetchChartData(this._period);

      this._isLoading = false;
    } catch (err) {
      throw err;
    }
  }
  @computed
  get assessList() {
    return this._assessList;
  }
  @computed
  get total() {
    return this._total;
  }

  @action
  setAssess(assess: AssessModel) {
    this._assess = assess;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setUserInfo(userInfo: UserModel) {
    this._userInfo = userInfo;
  }
  @action
  setIsChecked(isChecked: boolean) {
    this._isChecked = isChecked;
  }
  @action
  setTabValue(tabValue: string) {
    this._tabValue = tabValue;
  }
  @action
  setFilterValue(value: string) {
    this._filterValue = value;
  }
  @action
  setFilterLikeDown(filterLikeDown: boolean) {
    this._filterLikeDown = filterLikeDown;
  }

  @action
  setPeriod(period: string) {
    this._period = period;
  }

  @action
  setFilterLikeUp(filterLikeUp: boolean) {
    this._filterLikeUp = filterLikeUp;
  }

  @computed
  get containers() {
    return this._containers;
  }
  @computed
  get isEmpty() {
    return this._containers.length === 0;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }

  @computed
  get last30dayAvg() {
    return this._last30dayAvg;
  }

  @computed
  get quarterAvg() {
    return this._quarterAvg;
  }

  @computed
  get halfAvg() {
    return this._halfAvg;
  }

  @computed
  get yearAvg() {
    return this._yearAvg;
  }

  @computed
  get last30dayEmojiCount() {
    return this._last30dayEmojiCount;
  }

  @computed
  get quarterEmojiCount() {
    return this._quarterEmojiCount;
  }

  @computed
  get halfEmojiCount() {
    return this._halfEmojiCount;
  }

  @computed
  get yearEmojiCount() {
    return this._yearEmojiCount;
  }

  @computed
  get userInfo() {
    return this._userInfo;
  }
  @computed
  get isChecked() {
    return this._isChecked;
  }
  @computed
  get tabValue() {
    return this._tabValue;
  }
  @computed
  get filterValue() {
    return this._filterValue;
  }

  @computed
  get labels() {
    return this._labels;
  }

  @computed
  get scores() {
    return this._scores;
  }

  @computed
  get task() {
    return this._task;
  }

  @computed
  get filterLikeUp() {
    return this._filterLikeUp;
  }

  @computed
  get filterLikeDown() {
    return this._filterLikeDown;
  }

  @computed
  get isLoading() {
    return this._isLoading;
  }

  @computed
  get period() {
    return this._period;
  }

  @action
  setEmogiList(emogiList: any) {
    this._emogiList = emogiList;
  }

  @computed
  get emogiList() {
    return this._emogiList;
  }

  @computed
  get totalEmoji() {
    return this._totalEmoji;
  }

  @computed
  get maxEmojiCount() {
    return this._maxEmojiCount;
  }
  @computed
  get minEmojiCount() {
    return this._minEmojiCount;
  }
}

export default TimelinePageStore;
